export default "__VITE_ASSET__ZiKgTaEI__"